'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Services


// Utils


// Selectors


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _recompose = require('recompose');

var _userService = require('../userService');

var _resourceUtil = require('../../utils/services/http/resources/resourceUtil');

var _cssUtil = require('../../utils/cssUtil');

var _usersSelector = require('../usersSelector');

var _UserAvatar = require('../../components/userAvatar/UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

require('./ElementUserTag.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TAG_TYPE_ACTIVE = 'TAG_TYPE_ACTIVE';
var TAG_TYPE_FILTER = 'TAG_TYPE_FILTER';

var makeRemoteTagSelector = function makeRemoteTagSelector() {
    return (0, _reselect.createSelector)(function (state, ownProps) {
        return ownProps.isRemotelySelected;
    }, function (state, ownProps) {
        return ownProps.remoteSelectionData;
    }, function (state) {
        return state.get('users');
    }, function (isRemotelySelected, remoteSelectionData, users) {
        if (!isRemotelySelected) return null;

        var userId = remoteSelectionData.get('userId');

        return {
            user: users.get(userId),
            userId: userId,
            type: TAG_TYPE_ACTIVE
        };
    });
};

var makeFilterTagSelector = function makeFilterTagSelector() {
    return (0, _reselect.createSelector)(function (state, ownProps) {
        return ownProps.filter;
    }, function (state, ownProps) {
        return ownProps.element;
    }, function (state) {
        return state.get('users');
    }, function (filter, element, users) {
        if (!filter || filter !== 'filter-pass') return null;

        var userId = element.getIn(['meta', 'modifiedBy']);

        return {
            user: users.get(userId),
            userId: userId,
            type: TAG_TYPE_FILTER
        };
    });
};

var makeElementUserTagSelector = function makeElementUserTagSelector() {
    return (0, _reselect.createSelector)(_usersSelector.userResourcesSelector, makeRemoteTagSelector(), makeFilterTagSelector(), function (userResources, remoteTag, filterTag) {
        if (!remoteTag && !filterTag) return {};

        var tag = remoteTag || filterTag;
        var userId = tag.userId;
        var userResourceState = userResources.get(userId);

        return _extends({}, tag, {
            isUserFetched: (0, _resourceUtil.isFetched)(userResourceState)
        });
    });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        loadUser: function loadUser(userId) {
            return dispatch((0, _userService.fetchUsers)([userId]));
        }
    };
};

var getTagStyle = function getTagStyle(_ref) {
    var top = _ref.top,
        left = _ref.left;

    if (!top || !left) return null;

    return (0, _cssUtil.getTranslationStyles)({ x: left, y: top });
};

var ElementUserTag = function ElementUserTag(_ref2) {
    var user = _ref2.user,
        type = _ref2.type,
        top = _ref2.top,
        left = _ref2.left;
    return _react2.default.createElement(
        'div',
        { className: 'ElementUserTag', style: getTagStyle({ top: top, left: left }) },
        _react2.default.createElement(_UserAvatar2.default, { user: user,
            pulse: type === TAG_TYPE_ACTIVE,
            active: type === TAG_TYPE_ACTIVE,
            filter: type === TAG_TYPE_FILTER })
    );
};

var ElementUserTagContainer = (_dec = (0, _reactRedux.connect)(makeElementUserTagSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(ElementUserTagContainer, _React$Component);

    function ElementUserTagContainer() {
        _classCallCheck(this, ElementUserTagContainer);

        return _possibleConstructorReturn(this, (ElementUserTagContainer.__proto__ || Object.getPrototypeOf(ElementUserTagContainer)).apply(this, arguments));
    }

    _createClass(ElementUserTagContainer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var user = nextProps.user,
                userId = nextProps.userId,
                loadUser = nextProps.loadUser,
                isUserFetched = nextProps.isUserFetched;


            if (user && !isUserFetched) {
                loadUser(userId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                type = _props.type,
                top = _props.top,
                left = _props.left;


            return _react2.default.createElement(
                _CSSTransitionGroup2.default,
                {
                    transitionName: 'pop',
                    transitionAppear: true,
                    transitionAppearTimeout: 500,
                    transitionEnterTimeout: 500,
                    transitionLeaveTimeout: 500 },
                user ? _react2.default.createElement(ElementUserTag, { user: user, type: type, top: top, left: left }) : null
            );
        }
    }]);

    return ElementUserTagContainer;
}(_react2.default.Component)) || _class);


ElementUserTag.propTypes = ElementUserTagContainer.propTypes = {
    remoteSelectionData: _propTypes2.default.object,
    lastModifiedUser: _propTypes2.default.object,
    isRemotelySelected: _propTypes2.default.bool,
    filter: _propTypes2.default.string,
    user: _propTypes2.default.object,
    userId: _propTypes2.default.string,
    type: _propTypes2.default.string,
    isUserFetched: _propTypes2.default.bool,
    top: _propTypes2.default.number,
    left: _propTypes2.default.number
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(ElementUserTagContainer);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/userActivity/ElementUserTag.js
// module id = 203
// module chunks = 0